export default function initAboutPageSwiper() {
  const teamContainer = document.querySelector(".team-container");

  if (!teamContainer) return;

  new Swiper(teamContainer, {
    loop: true,
    spaceBetween: 16,
    grabCursor: true,
    autoHeight: true,

    autoplay: {
      delay: 3000,
    },

    navigation: {
      nextEl: ".view-next-exco",
      prevEl: ".view-prev-exco",
    },

    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
}

// Check if we are in an ACF block preview environment and hook into its render action.
if (window.acf) {
  window.acf.addAction(
    "render_block_preview/type=about-page",
    initAboutPageSwiper
  );
} else {
  document.addEventListener("DOMContentLoaded", initAboutPageSwiper);
}
